<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items" style="margin-top: 2%;">
          <div>
            <div class="form-row newDesign" style="width: 100%" v-if="showExpired">
              <span class="logo" style="width: 100%;" v-html="logos"></span>
              <span v-if="successmsg != 'Schedule Request is Expired'" class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
                <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!</strong></p>
                <br><br>
            </div>
            <div class="form-row newDesign" style="width: 100%" v-if="acceptance && !showExpired">
              <span class="logo" style="width: 100%;" v-html="logos"></span>
              <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
                <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!</strong></p>
                <br><br>
            </div>
            <div class="form-row newDesign" style="width: 100%" v-if="!acceptance && !showExpired">
                <span class="logo" style="width: 100%;" v-html="logos"></span><br>
                <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{allTitle}}</strong></p>
                <br><br>
                <table class="table table-bordered acstable">
                <tr>
                  <td><b>Job Title:</b> </td>
                  <td>{{data.job_tittle}}</td>
                </tr>
                <tr>
                  <td><b>Candidate Name: </b></td>
                  <td>{{data.candidate_name}} {{data.candidate_lastname}}</td>
                </tr>
                <!-- <tr>
                  <td><b>Interview Date: </b></td>
                  <td>{{getDate(data.startdatetime_utc)}}</td>
                </tr> -->
                <tr v-if="data.reschedule_tag !== 'Yes'">
                  <td><b>Interview Time ({{timezoneApp}}): </b></td>
                  <td>{{getDate(data.startdatetime_utc)}} {{getTime(data.startdatetime_utc)}} - {{getTime(data.enddatetime_utc)}}</td>
                </tr>
                <!-- <tr v-if="data.reschedule_tag !== 'Yes'">
                  <td><b>Interview Time ({{timezoneApp}}): </b></td>
                  <td>{{getDate(data.startdatetime_utc)}} {{getTime(data.startdatetime_utc)}} - {{getTime(data.enddatetime_utc)}}</td>
                </tr> -->
                <tr v-if="data.reschedule_tag === 'Yes'">
                  <td><b>Interview Time ({{timezoneApp}}): </b></td>
                  <td>{{getDate(data.restartdatetime_utc)}} {{getTime(data.restartdatetime_utc)}} - {{getTime(data.reenddatetime_utc)}}</td>
                </tr>
                <!-- <tr v-if="data.reschedule_tag === 'Yes'">
                  <td><b>Interview Time ({{timezoneApp}}): </b></td>
                  <td>{{getDate(data.restartdatetime_utc)}} {{getTime(data.restartdatetime_utc)}} - {{getTime(data.reenddatetime_utc)}}</td>
                </tr> -->
                <tr v-if="type == '2'">
                  <td><b>Candidate Resume: </b></td>
                  <td><a :href="data.candidate_resume"> {{data.candidate_resume}}</a></td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                </tr>
              </table>
              <div style="text-align: center;width: 100%;" v-if="data.status != 'Auto-Declined'">
                <button class="btn btn-success" @click="accept()">Accept</button> &nbsp; <button class="btn btn-danger" @click="decline()">Decline</button>
              </div>
              <div style="text-align: center;color:red;width: 100%;" v-if="data.status == 'Auto-Declined'">
                <b>Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { REGISTERATION_SUCCESS, logo } from '../../shared/svg'
// import router from '../../router/index'
// import moment from 'moment'
import { BaseURL } from '../../shared/classes'
import axios from 'axios'
import momentsone from 'moment-timezone'
import moment from 'moment'
const timezonList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]
export default {
  name: 'registerationComplete',
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo,
      timezone: momentsone.tz.guess(),
      timezonetype: 'IST',
      scheduleId: this.$route.params.scheduleId,
      type: this.$route.params.type,
      data: [],
      BaseURL: BaseURL,
      acceptance: false,
      showExpired: false,
      allTitle: 'Interview Schedule Request!',
      successmsg: '',
      typename: '',
      config: {},
      timezoneApp: '',
      usertimezone: momentsone.tz.guess()
    }
  },
  created () {
    const currentTime = moment().tz(moment.tz.guess())
    this.timezoneApp = currentTime.format('z')
    if (this.type === '2' || this.type === 2) {
      this.typename = 'interviewer'
    } else {
      this.typename = 'candidate'
    }
    if (this.timezoneApp === 'EDT') {
      this.timezoneApp = 'EST'
    } else if (this.timezoneApp === 'PDT') {
      this.timezoneApp = 'PST'
    } else if (this.timezoneApp === 'AKDT') {
      this.timezoneApp = 'AHST'
    }
    this.getscheduleDetails(this.scheduleId)
  },
  methods: {
    getDate (date) {
      if (this.typename === 'candidate') {
        const listtime = timezonList.find(item => { return String(item.name) === String(this.timezoneApp) })
        this.usertimezone = listtime.name
        return momentsone.utc(date).tz(listtime.fullName).format('DD MMM YYYY')
      } else {
        this.usertimezone = this.data.schedule_interviewer_timezone
        this.timezoneApp = this.usertimezone
        if (this.timezoneApp) {
          const listtime = timezonList.find(item => { return String(item.name) === String(this.timezoneApp) })
          return momentsone.utc(date).tz(listtime.fullName).format('DD MMM YYYY')
        }
      }
    },
    getTime (date) {
      // let timezone = ''
      if (this.typename === 'candidate') {
        const listtime = timezonList.find(item => { return String(item.fullName) === String(this.timezone) })
        this.usertimezone = listtime.name
        return momentsone.utc(date).tz(listtime.fullName).format('hh:mm a')
      } else {
        this.timezoneApp = this.data.schedule_interviewer_timezone
        if (this.timezoneApp) {
          const listtime = timezonList.find(item => { return String(item.name) === String(this.timezoneApp) })
          return momentsone.utc(date).tz(listtime.fullName).format('hh:mm a')
        }
      }
    },
    getscheduleDetails (id) {
      const mainurl = '/dashboard/get_schedule_detail/' + id
      axios.get(`${this.BaseURL}${mainurl}`, this.config).then(response => {
        if (response.data.refer_tag !== 'self') {
          this.data = response.data.scheduleList[0]
        } else {
          this.data = response.data.scheduleList_self[0]
        }
        if (this.data.status === 'Reschedule Requested' || this.data.reschedule_status === 'Accepted') {
          this.allTitle = 'Interview Reschedule Request!'
          if (this.data.status === 'Expired') {
            this.showExpired = true
            this.successmsg = 'Schedule Request is Expired'
          } else if (this.data.status === 'Declined') {
            this.showExpired = true
            this.successmsg = 'Schedule Request is declined'
          } else if (this.data.interviewer_resch_accept === 'yes' && this.typename === 'interviewer') {
            this.showExpired = true
            this.successmsg = 'Schedule Request already accepted'
          } else if (this.data.candidate_resch_accept === 'yes' && this.typename === 'candidate') {
            this.showExpired = true
            this.successmsg = 'Schedule Request already accepted'
          }
        } else {
          if (this.data.status === 'Expired') {
            this.showExpired = true
            this.successmsg = 'Schedule Request is Expired'
          } else if (this.data.status === 'Declined') {
            this.showExpired = true
            this.successmsg = 'Schedule Request is declined'
          } else if (this.data.interviewer_accept === 'yes' && this.typename === 'interviewer') {
            this.showExpired = true
            this.successmsg = 'Schedule Request already accepted'
          } else if (this.data.candidate_accept === 'yes' && this.typename === 'candidate') {
            this.showExpired = true
            this.successmsg = 'Schedule Request already accepted'
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    accept () {
      let mainurl = ''
      if (this.data.status === 'Reschedule Requested' || this.data.reschedule_status === 'Accepted') {
        mainurl = '/dashboard/reschedule_accept_acs/' + this.scheduleId
      } else {
        mainurl = '/dashboard/schedule_accept_web_acs_new'
      }
      const listtime = timezonList.find(item => { return String(item.name) === String(this.timezoneApp) })
      const formData = {
        _id: this.scheduleId,
        accept_by: this.typename,
        schedule_candidate_timezone: listtime.name
      }
      axios.post(`${this.BaseURL}${mainurl}`, { formData: formData }, this.config).then(response => {
        this.successmsg = 'Thanks for the acknowledgement. Please check your email for further details about the schedule.'
        this.acceptance = true
      }).catch(e => {
        console.log(e)
      })
    },
    decline () {
      let mainurl = ''
      if (this.data.status === 'Reschedule Requested' || this.data.reschedule_status === 'Accepted') {
        mainurl = '/dashboard/reschedule_declined_web_acs/'
      } else {
        mainurl = '/dashboard/schedule_declined_web_acs_new'
      }
      const formData = {
        _id: this.scheduleId,
        decline_by: this.typename
      }
      axios.post(`${this.BaseURL}${mainurl}`, { formData: formData }, this.config).then(response => {
        this.successmsg = 'Thanks for your response. We will keep the recruiter informed about your unavailability'
        this.acceptance = true
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.form-holder {
  margin-left: 0px;
  width: 100%;
}
.success-text-align {
  width: 100%;
  font-weight: 400;
}
.success-sub-text-align {
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content p {
  line-height: 5px;
}
.logo-size {
  width: 50%;
}

.table, th, td {
  border: 1px solid #252424b8;
  background-color: cornsilk;
}
.acstable td {
  width: 49%;
  padding-left: 11px;
  text-align: left;
}
</style>
